import { INote } from "@tylertech/tyler-api-types";

export function createNote(createdBy: string): INote
{
    return {
        CreatedDate: new Date(Date.now()),
        CreatedBy: createdBy,
        Description: undefined,
        Id: undefined,
        IsNew: true,
        IsDeleted: false,
        ParentId: undefined,
        RecordVersion: undefined,
        Subject: undefined,
    };
}
